export default interface IApplicationBaseVm {
    id: string
}

export const empty = (enableIteration: boolean = true): IApplicationBaseVm => {
	return {
		id: ""
	} as IApplicationBaseVm
}